import Jazzicon from './Jazzicon';

export default Jazzicon;
